var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "url(#green-check-circle_svg__paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.677 18a.995.995 0 01-.729-.323L6.302 13.78a1.157 1.157 0 010-1.56.985.985 0 011.458 0l2.917 3.118 6.563-7.015a.985.985 0 011.458 0c.403.43.403 1.128 0 1.559l-7.292 7.795a.996.996 0 01-.729.323z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "green-check-circle_svg__paint0_linear",
    x1: 12.5,
    y1: 0,
    x2: 12.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FDEA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DCFAE"
  })))));
}

export default __webpack_public_path__ + "./fonts/green-check-circle.d3db05b6844d1d0a92121802477018c6.svg";
export { SvgGreenCheckCircle as ReactComponent };